import requests from "./httpService";

const PastDaysService = {
    getPastDays(company_id) {
        return requests.get(`/pastdays/get?company_id=${company_id}`);
    },
    createPastDays(body) {
        return requests.post(`/pastdays/create`, body);
    },
    updatePastDays(id, body) {
        return requests.post(`/pastdays/update/${id}`, body);
    },
    deletePastDays(id) {
        return requests.delete(`/pastdays/delete/${id}`);
    },
};

export default PastDaysService;
